export function unique<T>(xs: T[]) {
    return xs.reduce((a, v) => {
        if (!a.includes(v)) a.push(v);
        return a;
    }, [] as T[]);
}
